import { startOfMonth, endOfMonth, subMonths, isSameMonth } from "date-fns";
import { DateParam, useQueryParam } from "use-query-params";
import { MonthSelectorWrap } from "./styles";
import { useState, useEffect } from "react";

const MonthSelector: React.FC = () => {
  const [startDate, setStartDate] = useQueryParam("startDate", DateParam);
  const [, setEndDate] = useQueryParam("endDate", DateParam);
  const [selectedMonth, setSelectedMonth] = useState<Date | null>(null);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  // Generate last 11 months + current month (current month at the rightmost side)
  const rotatedMonths = Array.from({ length: 12 }, (_, i) => {
    const monthDate = subMonths(new Date(), 11 - i); // Move backward to get the correct sequence
    return {
      name: months[monthDate.getMonth()], // Get month name
      date: monthDate // Store actual date object for reference
    };
  });

  // Set initial selected month from query param if available
  useEffect(() => {
    if (startDate) {
      setSelectedMonth(startOfMonth(new Date(startDate)));
    }
  }, [startDate]);

  const handleMonthSelection = (selectedMonthDate: Date) => {
    const start = startOfMonth(selectedMonthDate);
    const end = endOfMonth(selectedMonthDate);

    setStartDate(start);
    setEndDate(end);
    setSelectedMonth(start); // Track selected month
  };

  return (
    <MonthSelectorWrap>
      <img
        src="https://res.cloudinary.com/dyuuf6gor/image/upload/f_auto,q_auto/gifts/mta-logo_bkswne.png"
        alt=""
        className="madLogo"
      />
      <div className="monthSelectorWrap">
        {rotatedMonths.map(({ name, date }) => (
          <div
            key={name}
            onClick={() => handleMonthSelection(date)}
            className={`monthSelector ${selectedMonth && isSameMonth(date, selectedMonth) ? "selected" : ""}`}
          >
            {name}
          </div>
        ))}
      </div>
    </MonthSelectorWrap>
  );
};

export default MonthSelector;
